import PrimeReact from 'primereact/api';
import './utils/polyfills';
import ReactDOM from 'react-dom/client';

// Ensure overlays (Calendar, Dropdown, etc.) always render above modals (Dialog)
PrimeReact.zIndex = {
    modal: 1100,
    overlay: 1200,
    menu: 1000,
    tooltip: 1100,
    toast: 1200,
};
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SpanishMessages from './lang/es.json';
import EnglishMessages from './lang/en.json';
import App from './App';
import { Provider } from 'react-redux';
import { ApiProvider, MuifProvider, ErrorBoundary, WindowLoader, NetworkStatus, WindowProgressBar, ConfirmProvider } from 'medere-ui-framework';
import { store } from './redux/store';
import esPrimeReact from './lang/esPrimeReact.json';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';
import './index.css';
import 'medere-ui-framework/dist/style.css';
import './scss/tokens.css';
import './scss/styles.scss';

// Extender HTMLElement para incluir la propiedad _reactRootContainer
declare global {
  interface HTMLElement {
    _reactRootContainer?: ReactDOM.Root;
  }
}

function MainComponent() {
  const router = createBrowserRouter([{
    path: "*",
    element:
      <ApiProvider baseURL={globalThis.location.origin}>
        <MuifProvider
          messagesArray={[{ ...SpanishMessages, ...esPrimeReact }, EnglishMessages]}
          localeArray={['es', 'en']} >
          <ErrorBoundary>
            <Provider store={store}>
              <ConfirmProvider>
                <App />
                <NetworkStatus />
                <WindowLoader />
                <WindowProgressBar />
              </ConfirmProvider>
            </Provider>
          </ErrorBoundary>
        </MuifProvider>
      </ApiProvider>
  }]);
  return <RouterProvider router={router} />;
}

const container = document.getElementById('root');

if (!container._reactRootContainer) {
  const root = ReactDOM.createRoot(container);
  container._reactRootContainer = root; // Asignar la referencia para evitar futuras inicializaciones
  root.render(<MainComponent />);
}
